module.exports = __webpack_public_path__ + "static/cer_dor_4-b627a6bd85db0d7d42414ffd53fddfc9.jpg";